import React from "react";
import { FaEdit } from "react-icons/fa";
import { useProfile } from "../context/ProfileContext";

export default function DocumentStatusEditor({
  statusForm,
  setStatusForm,
  isEditing,
  onEdit,
  onCancel,
  onSave,
  editable = true,
  userRole,
}) {
  // 
  const { profile, assignModule } = useProfile();
  const isNewType = profile?.employeeType === "new";
  // Prevent error when statusForm is undefined
  if (!statusForm) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "status") {
      setStatusForm((prev) => {
        const newState = { ...prev };

        // Preserve revisit reason
        if (prev.status === "Revisit") {
          newState.lastRevisitReason = prev.statusReason;
        }

        let newReason = "";
        if (value === "Revisit") {
          newReason = prev.lastRevisitReason || "";
        }

        return {
          ...newState,
          status: value,
          statusReason: value === "Rejected" ? "" : newReason,
        };
      });
    } else {
      setStatusForm((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  return (
    <div className="mt-6 border-t pt-4">
      <strong>Status:</strong>{" "}
      {isEditing ? (
        <div className="grid gap-4 mt-2">
          <select
            name="status"
            value={statusForm.status}
            onChange={handleChange}
            className="border p-2 rounded w-full"
          >
            <option value="Pending">Pending</option>
            <option value="InProgress">In Progress</option>
            <option value="Revisit">Revisit</option>
            <option value="Verified">Verified</option>
            <option value="Rejected">Rejected</option>
            {(userRole === "senior" || userRole === "superadmin" || isNewType)  && (
              <option value="Onboarded">Onboarded</option>
            )}
            {/* <option value="Onboarded">Onboarded</option> */}
          </select>

          {(statusForm.status === "Rejected" ||
            statusForm.status === "Revisit") && (
            <textarea
              name="statusReason"
              value={statusForm.statusReason}
              onChange={handleChange}
              placeholder="Rejection Reason"
              className="border p-2 rounded w-full"
            />
          )}

          <div className="flex justify-between">
            <button
              type="button"
              onClick={onCancel}
              className="bg-gray-600 text-white px-4 py-2 rounded"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onSave}
              className="bg-blue-600 text-white px-4 py-2 rounded"
            >
              Save Changes
            </button>
          </div>
        </div>
      ) : (
        <span className="flex items-center gap-2">
          {statusForm.status}
          {(statusForm.status === "Rejected" ||
            statusForm.status === "Revisit") && (
            <span className="text-sm text-gray-600">
              ({statusForm.statusReason || "N/A"})
            </span>
          )}
          {editable && (
            <FaEdit
              className="text-blue-600 cursor-pointer ml-2"
              onClick={onEdit}
            />
          )}
        </span>
      )}
    </div>
  );
}
